<template>
  <o-section
    :level="level + 1"
    :title="label || schema.verbose_name"
    body-classes="p-0"
    not-closable
  >
    <o-item-editable-table
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
      v-model="items"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'date_billed')">
          {{ schema.fields.date_billed.label }}
        </th>
        <th v-if="canSee(schema, 'bill_number')">
          {{ schema.fields.bill_number.label }}
        </th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'date_billed')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="date_billed"
          >
            <o-date-time
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              hide-time
              name="date_billed"
              nolabel
              v-bind="schema.fields.date_billed"
              v-model="items[index].date_billed"
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'bill_number')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="bill_number"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="bill_number"
              nolabel
              v-bind="schema.fields.bill_number"
              v-model="items[index].bill_number"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";

export default {
  name: "BillFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("Bill"),
    CreateCodeTableFetchMixin([]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(schema.Bill, {}) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.Bill),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
